// The one classic page the flow leaves for: the actor's dashboard, once the flow
// is over ("Go to my dashboard", and "Explore more opportunities!" once sent).
// Signed in the way the classic signup's completion pages do it (tk = the
// session key, cid = the client id), so the actor lands there logged in.
// Nothing else in the flow goes to a classic .asp page.
//
// In the mock there is no classic site: its stand-in dashboard instead.

import { getSubmissionAuth, getSubmissionWebSessionKey } from "../../../helpers/submissionAuth";
import { isMockApi } from "../../../shared/api/submission";

export const MOCK_DASHBOARD_PATH = "/submission/mock-dashboard";

// page: the classic dashboard's section to open (page=breakdowns for the
// casting calls).
export const dashboardUrl = (page?: string): string => {
  if (isMockApi()) return MOCK_DASHBOARD_PATH;
  const base = (process.env.REACT_APP_CWB_Site || "").replace(/\/+$/, "");
  const params = new URLSearchParams();
  const key = getSubmissionWebSessionKey();
  const auth = getSubmissionAuth();
  if (key) params.set("tk", key);
  if (auth && auth.clientId) params.set("cid", String(auth.clientId));
  if (page) params.set("page", page);
  const query = params.toString();
  return `${base}/actorsworkbook/default.asp${query ? `?${query}` : ""}`;
};

// Absolute (another domain, protocol-relative included) leaves the app; the
// mock's stand-in is a route in it.
export const goToDashboard = (history: { push: (path: string) => void }, page?: string) => {
  const url = dashboardUrl(page);
  if (/^(https?:)?\/\//i.test(url)) window.location.assign(url);
  else history.push(url);
};
